/**
 * Static, non-secret, environment-invariant constants.
 *
 * These values:
 *  - are NOT secrets,
 *  - do NOT change between dev / test / stage / prod,
 *
 * and were previously stored as environment variables. They are kept as
 * code-level constants so they don't have to be plumbed through the env.
 *
 * NOTE: Do NOT add anything here that:
 *  - differs between environments (e.g., base URLs, proxy app numbers,
 *    Firebase project config, feature flags), or
 *  - is sensitive (tokens, JWT secrets, encryption keys, app hashes).
 */

// ---------------------------------------------------------------------------
// Hello bot function endpoints (paths under the bot socket base URL)
// ---------------------------------------------------------------------------

export const MSG91_HELLO_BOT_EXAMPLE_API = '/func/JQU9Ks8Y7XxS';
export const MSG91_HELLO_BOT_PROMPT_API = '/func/ucTYNbAj1MD4';
export const MSG91_HELLO_BOT_COMPANY_ID_API = '/func/rdmShdd4YqTR';
export const MSG91_HELLO_BOT_DEFAULT_MESSAGE = '/func/HzRcOi8AagJJ';

export const MSG91_HELLO_BOT_PROXY_BASE_URL = 'https://routes.msg91.com/api/proxy/870623/20mlzdb17';
export const MSG91_HELLO_BOT_SOCKET_BASE_URL = 'https://flow.sokt.io';
export const MSG91_ENABLE_MSG91_PROXY = true;

const getHelloBotApiUrl = (path: string): string =>
    MSG91_ENABLE_MSG91_PROXY ? `${MSG91_HELLO_BOT_SOCKET_BASE_URL}${path}` : `${MSG91_HELLO_BOT_PROXY_BASE_URL}${path}`;

export const MSG91_HELLO_BOT_EXAMPLE_API_URL = getHelloBotApiUrl(MSG91_HELLO_BOT_EXAMPLE_API);
export const MSG91_HELLO_BOT_PROMPT_API_URL = getHelloBotApiUrl(MSG91_HELLO_BOT_PROMPT_API);
export const MSG91_HELLO_BOT_COMPANY_ID_API_URL = getHelloBotApiUrl(MSG91_HELLO_BOT_COMPANY_ID_API);
export const MSG91_HELLO_BOT_DEFAULT_MESSAGE_URL = getHelloBotApiUrl(MSG91_HELLO_BOT_DEFAULT_MESSAGE);

// ---------------------------------------------------------------------------
// Hello bot demo / tutorial URLs
// ---------------------------------------------------------------------------

export const MSG91_HELLO_AGENTIC_AI_CHATBOT_URL =
    'https://www.youtube.com/watch?v=OLnxjy8jL88&list=PLOBLGD3o3_7MqOk115az9S4Pk_Ko-q-3s&index=5';
export const MSG91_HELLO_SAVE_USER_DETAIL_BOT_URL =
    'https://www.youtube.com/watch?v=OYV-EsPKCao&list=PLOBLGD3o3_7MqOk115az9S4Pk_Ko-q-3s&index=7';
export const MSG91_HELLO_GATEWAY_AI_SETUP_URL =
    'https://app.supademo.com/demo/cml6hjfb75i5wzsadp10a2cll?utm_source=link&step=17';

// ---------------------------------------------------------------------------
// Viasocket
// ---------------------------------------------------------------------------

export const MSG91_VIASOCKET_BASE_URL = 'https://flow-api.viasocket.com';
export const MSG91_SHOW_VIASOCKET_FLOWS = true;
export const MSG91_VIASOCKET_ORIGIN_URL = 'https://embedfrontend.viasocket.com';
